import { ApiResponseData, api } from '~shared/api';

import { routes } from './routes';
import { ApiOrgInfoData, ApiPortfolioData, ApiRequest } from './types';

export const getOrgInfo = ({ idOrganization }: ApiRequest) => {
  return api.post<any, ApiResponseData<ApiOrgInfoData>>(routes.getOrgInfo(), {
    idOrganization,
  });
};

export const getPortfolio = ({ idOrganization }: ApiRequest) => {
  return api.post<any, ApiResponseData<ApiPortfolioData>>(routes.getPortfolio(), {
    idOrganization,
  });
};
